













import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { PostReactionCountEntity } from '@/entities/post-reaction-count.entity';
import GiftReactionItem from '@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessageItem/GiftReactionItem.vue';

@Component<ReactionList>({
  components: { GiftReactionItem },
})
export default class ReactionList extends Vue {
  @Prop({ type: Array as PropType<PostReactionCountEntity[]> })
  reactions: PostReactionCountEntity[];

  get totalReaction() {
    return this.reactions.reduce(
      (total, reaction) => total + Number(reaction.count),
      0,
    );
  }
}
